import React from 'react';

import { GapWord } from 'shared/types';

interface Props {
  gapWord: GapWord;
  isInputDisabled: boolean;
  changeFormikGapWords: (currentGapWord: GapWord) => void;
}

export const StudentGapLetter = ({ gapWord, changeFormikGapWords, isInputDisabled }: Props) => (
  <div className="flex">
    <p className="!mb-0 text-lg font-medium leading-[25px] lg:text-xl">{gapWord.word.split('_')[0]}</p>

    <input
      value={gapWord.answer}
      onChange={event => changeFormikGapWords({ ...gapWord, answer: event.target.value })}
      className="w-4 border-b-2 border-black text-center text-lg font-medium leading-[25px] lg:w-5 lg:text-xl"
      maxLength={1}
      disabled={isInputDisabled}
    />

    <p className="!mb-0 text-lg font-medium leading-[25px] lg:text-xl">{gapWord.word.split('_')[1]}</p>
  </div>
);
